import { render, staticRenderFns } from "./snap01_format.vue?vue&type=template&id=5302fc5b"
import script from "./snap01_format.vue?vue&type=script&lang=js"
export * from "./snap01_format.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports